/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DataSourceProvider = "Google" | "Office365" | "%future added value";
export type DataSourceStatus = "Okay" | "RequiresReAuth" | "%future added value";
export type DataSource_dataSource = {
    readonly id: string;
    readonly name: string | null;
    readonly calendarIds: ReadonlyArray<string | null> | null;
    readonly syncTargets: ReadonlyArray<{
        readonly emailAddress: string | null;
        readonly calendarId: string | null;
    } | null> | null;
    readonly state: DataSourceStatus | null;
    readonly type: DataSourceProvider | null;
    readonly username: string | null;
    readonly " $refType": "DataSource_dataSource";
};
export type DataSource_dataSource$data = DataSource_dataSource;
export type DataSource_dataSource$key = {
    readonly " $data"?: DataSource_dataSource$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DataSource_dataSource">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DataSource_dataSource",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calendarIds",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CrawlTarget",
            "kind": "LinkedField",
            "name": "syncTargets",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emailAddress",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        }
    ],
    "type": "DataSource",
    "abstractKey": null
} as any;
(node as any).hash = '09e08a63daf96a3c0fc2b92da0eb7e69';
export default node;
